/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { DriftStage } from './driftStage';
import type { RemoteStageOption } from './remoteStageOption';
import type { StageMappingItem } from './stageMappingItem';

export interface StageMappingListResponse {
  job_link_id: string;
  stage_sync_tier: string;
  link_origin: string;
  connector_name: string;
  remote_stages?: RemoteStageOption[];
  drift_stages?: DriftStage[];
  mappings: StageMappingItem[];
}
